export default "__VITE_ASSET__N14I6X$F__"